export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12914.95cdf246.jpg";